import type { ReactNode } from "react";

type EmptyStateProps = {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  bordered?: boolean;
  className?: string;
};

export default function EmptyState({ icon, title, description, action, bordered = false, className = "" }: EmptyStateProps) {
  const border = bordered ? "rounded-xl border border-dashed border-gray-300" : "";
  return (
    <div className={`flex flex-col items-center justify-center gap-3 px-4 py-10 text-center ${border} ${className}`}>
      {icon && <div className="text-gray-300">{icon}</div>}
      <p className="text-sm font-medium text-gray-600">{title}</p>
      {description && <p className="max-w-sm text-sm text-gray-400">{description}</p>}
      {action}
    </div>
  );
}
